/**
 * Design tokens for the Omega AI HPC Console (neo-brutalist theme).
 *
 * JS mirror of the Tailwind @theme variables in styles/tokens.css (the single
 * source of truth) — keep the two in sync. Inline styles read these; new
 * components should prefer Tailwind utility classes. Iron rules for any new
 * UI: frontend/DESIGN_SYSTEM.md.
 *
 * Color semantics (see .impeccable.md): accent orange = interactive ONLY,
 * green = approve/ok ONLY, red = veto/danger ONLY.
 */

// ── Core palette ──
export const COLORS = {
  bg:       "#faf6ec",
  panel:    "#ffffff",
  border:   "#000000",

  accent:   "#e24500",
  accentDim:"#ffe4d3",
  accentBr: "#b83700",
  accentFill:"#ff5b24",

  warn:     "#a86a00",
  warnDim:  "#fff0cc",

  danger:   "#cc1b00",
  dangerDim:"#ffded8",

  blue:     "#1f5fe0",
  blueDim:  "#dce8ff",

  violet:   "#7b4ba0",
  violetDim:"#f1eaf7",

  gold:     "#8a6d1a",
  goldDim:  "#f7f1dd",

  cyan:     "#0e7490",

  ok:       "#128a4b",
  okDim:    "#d9f5e4",

  text:     "#14110b",
  textDim:  "#4a463c",
  textBr:   "#000000",
  overlay:  "rgba(0, 0, 0, 0.45)",  // modal/dialog scrim; mirrors --color-overlay

  grid:     "#e6e2d6",
};

// ── Font stacks ──
// Only the mono stack is mirrored here. Display and body are read from the
// `--font-display` / `--font-sans` custom properties in tokens.css; the JS copies
// had no importer and were a second place for the two to drift.
export const MONO_FONT = "'Space Mono',ui-monospace,'SF Mono',monospace";               // data/labels

// ── Decision color map (semantic: green=approve, red=veto, amber=counter) ──
export const DECISION_COLORS = {
  approve:          COLORS.ok,
  veto:             COLORS.danger,
  counter_proposal: COLORS.warn,
};
